// Do some light platform detection
export const platform = {
    iOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    android: navigator.userAgent.toLowerCase().indexOf("android") > -1
};
